import { default as i18n } from "i18next";
import { initReactI18next } from "react-i18next";
import languageDetector from 'i18next-browser-languagedetector';
import translationEn from './locales/en'
import translationZh from "./locales/zh";
const resources = {
  en: {
    translation : translationEn
  },
  zh: {
    translation: translationZh
  }
}

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    debug: true,
    fallbackLng: "en",
    resources
  })

export default i18n;